import styled from 'styled-components';

export const Container = styled.div({
  marginLeft: '10rem',
});

export const Description = styled.div(({ theme }) => ({
  fontSize: '12rem',
  lineHeight: '14rem',
  position: 'absolute',
  top: '-15rem',
  color: theme.palette.sonicSilver,
}));
